/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./history-list.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./history-list.component";
var styles_HistoryListComponent = [i0.styles];
var RenderType_HistoryListComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_HistoryListComponent, data: {} });
export { RenderType_HistoryListComponent as RenderType_HistoryListComponent };
export function View_HistoryListComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_HistoryListComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-history-list", [], null, null, null, View_HistoryListComponent_0, RenderType_HistoryListComponent)), i1.ɵdid(1, 114688, null, 0, i2.HistoryListComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var HistoryListComponentNgFactory = i1.ɵccf("app-history-list", i2.HistoryListComponent, View_HistoryListComponent_Host_0, {}, {}, []);
export { HistoryListComponentNgFactory as HistoryListComponentNgFactory };
